import * as projectScheduleActions from '../actions/project-schedule.actions';
import { PagedEntity } from './index';

export interface ProjectScheduleState {
  pagedEntity: PagedEntity;
  error: any;
}

const initialState = {
  pagedEntity: null,
  error: null,
};

export const projectScheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case projectScheduleActions.GET_PROJECT_SCHEDULE:
      return {
        ...state,
        pagedEntity: null
      };

    case projectScheduleActions.GET_PROJECT_SCHEDULE_SUCCESS:
      return {
        ...state,
        error: null,
        pagedEntity: action.payload,
      };
    case projectScheduleActions.GET_PROJECT_SCHEDULE_FAIL:
      return {
        ...state,
        error: action.payload,
        pagedEntity: null
      };
    case projectScheduleActions.CLEAR_PROJECT_SCHEDULE:
      return {
        ...state,
        error: null,
        pagedEntity: null
      };
    default:
      return state;
  }
};

export const getProjectSchedule = (state: ProjectScheduleState) => state.pagedEntity;
